import { render, staticRenderFns } from "./ImageCropper.vue?vue&type=template&id=5c54f35a"
import script from "./ImageCropper.vue?vue&type=script&lang=ts"
export * from "./ImageCropper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports